module.exports = __webpack_public_path__ + "img/modelo-marmitaria.82c1bf1b.png";